import {FloteEndpointGroup} from "@/lib/api/endpoints/FloteEndpointGroup";

export class TransactionsApi extends FloteEndpointGroup {
    public downloadCsv() {
        return this.download(this.getFullUrl("download"));
    }
}
